import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useGlobalState } from '../core/context/AppContext';

const notificationVariants = {
  initial: {
    opacity: 0,
    y: -100,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -100,
  },
};

export const Notification = () => {
  const { notification, clearNotification } = useGlobalState();

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        clearNotification();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [notification, clearNotification]);

  if (!notification) return null;

  const { type = 'info', message } = notification;

  const bgColor = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    info: 'bg-blue-500',
    warning: 'bg-yellow-500',
  }[type];

  return (
    <AnimatePresence>
      <motion.div
        className={`fixed top-4 right-4 z-50 p-4 rounded shadow-lg ${bgColor} text-white`}
        variants={notificationVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        onClick={clearNotification}
      >
        <div className="flex items-center space-x-2">
          <span>{message}</span>
          <button
            onClick={(e) => {
              e.stopPropagation();
              clearNotification();
            }}
            className="ml-2 text-white hover:text-gray-200"
          >
            ✕
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export const useNotification = () => {
  const { setNotification } = useGlobalState();

  const showNotification = (message, type = 'info') => {
    setNotification({ message, type });
  };

  return {
    showSuccess: (message) => showNotification(message, 'success'),
    showError: (message) => showNotification(message, 'error'),
    showInfo: (message) => showNotification(message, 'info'),
    showWarning: (message) => showNotification(message, 'warning'),
  };
};
